import React from 'react';
import '../../App.css';

import { Skeleton } from '../ui/skeleton';
import {
    TableRow,
    TableCell,
} from '../ui/table';

export function SkeletonRow({ columns, rows = 1 }) {
    return (
        <>
            {Array(rows).fill().map((_, rowIndex) => (
                <TableRow key={rowIndex}>
                    {Array(columns).fill().map((_, colIndex) => (
                        <TableCell key={colIndex} className="pl-8 p-4">
                            <Skeleton className="h-5" />
                        </TableCell>
                    ))}
                </TableRow>
            ))}
        </>
    );
}
